<div class="quote">
    <p class="quote-text">" {{ currentQuote.quote }} "</p>
    <p class="quote-author">{{ currentQuote.author }}</p>
</div>
